import SSocket from "servisofts-socket";

const config = {
    reducer: "manualReducer",
    component: "manual"
}
export default class Actions {
   
}